module.exports = __webpack_public_path__ + "static/media/timeWindow_48.5dacc908.png";